import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {

  return (
    <>
      {/* Header Start */}
      <header>
            <nav className="navbar navbar-expand-sm bg-dark navbar-dark">
                <div className="container">
                
                    <Link className="navbar-brand" to="/"><h2>ILANDER</h2></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                          <Link className="nav-link" to="/home">Home</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/about">About</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/courses">Courses</Link>
                        </li>
                        <li class="nav-item dropdown">
                          <Link class="nav-link dropdown-toggle" to="/services" role="button" data-bs-toggle="dropdown">Services</Link>
                          <ul class="dropdown-menu">
                            <li><Link class="dropdown-item" to="/services/webdesign">WebDesign</Link></li>
                            <li><Link class="dropdown-item" to="/services/webdev">WebDevelopment</Link></li>
                            <li><Link class="dropdown-item" to="/services/digital">Digital</Link></li>
                          </ul>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/table">Table</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/contact">Contact</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/register">Register</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/register2">Register2</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/login">Login</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/parent">Parent</Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link" to="/cart">Cart</Link>
                        </li>
                    </ul>
                    </div>
                
                </div>
            </nav>
            </header>
        {/* Header End */}
    </>
  )
}

export default Header
